import { useContext } from "react";
import { Container } from "./language.styles";
import languageSvg from "../../assets/icons/language-svg.svg";
import { LanguageContext } from "../../contexts/language.context";
import { setLanguageUrl } from "../../utils/hashNavigation";

const Language = () => {
  const { romanianLanguage, setRomanianLanguage } = useContext(LanguageContext);

  const onChangeLanguageHandler = (e) => {
    const selectedLanguage = e.target.value;
    const isRomanianLanguage = selectedLanguage === "romanian";

    setRomanianLanguage(isRomanianLanguage);
    setLanguageUrl(isRomanianLanguage);
  };

  return (
    <Container>
      <img src={languageSvg} alt="" />
      <select
        name="language"
        id="language"
        value={romanianLanguage ? "romanian" : "russian"}
        onChange={onChangeLanguageHandler}
      >
        <option value="russian">En</option>
        <option value="romanian">It</option>
      </select>
    </Container>
  );
};

export default Language;
